export default "__VITE_ASSET__fa319aff__"